/* //-----------------------------------------------------------------------
<copyright file="transactions.ts" company="LGT India">
    Author: Sivapriya , Vanaraj
    Copyright (c) LGT India. All rights reserved.
</copyright>
----------------------------------------------------------------------- */
import { Component, Injectable, OnInit, ViewChild } from "@angular/core";
import { FormControl, Validators } from "@angular/forms";
import {
  NativeDateAdapter,
  provideNativeDateAdapter,
} from "@angular/material/core";
import {
  MatDatepickerInputEvent,
} from "@angular/material/datepicker";
import { PageEvent } from "@angular/material/paginator";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatSort, Sort } from "@angular/material/sort";
import { ApiService } from "../services/api.service";
import { saveAs } from 'file-saver';
import { AppComponent } from "../app.component";
import { DateAdapter, MAT_DATE_FORMATS } from "@angular/material/core";

@Injectable()
export class CustomDateAdapter extends NativeDateAdapter {
  override format(date: Date, displayFormat: Object): string { // Add the 'override' modifier here
    if (displayFormat === 'input') {
      const day = date.getDate().toString().padStart(2, '0');
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    }
    return date.toDateString();
  }
}


export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'input', // Use the 'input' format here
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
@Component({
  selector: "app-transactions",
  styleUrls: ["./transactions.component.css"],
  templateUrl: "./transactions.component.html",
  providers: [provideNativeDateAdapter(),
 // use Moment.js for date formatting
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS }, 
    { provide: DateAdapter, useClass: CustomDateAdapter },
  ],
})
export class TransactionsComponent implements OnInit {
  isTrue: boolean = false;
  isError: boolean = false;
  isLoading: boolean = false;
  IsDownloaded: boolean = false;
  dateFrom = new FormControl("", [Validators.required, Validators.required]);
  dateTo = new FormControl("", [Validators.required, Validators.required]);
  view = new FormControl("", [Validators.required, Validators.required]);
  showErrors: boolean = false;
  showSpinner: boolean = true;
  selectedOption: string = "TransactionsForPeriod";
  public transactionData: any = [];
  public incrementalTransctiondata: any = [];
  pageEvent = { page: 0, pageSize: 1, totalPage: 0, totalRecords: 0 };
  highestEventTSDate: string = "";
  public displayedColumns: string[] = [
    "no",
    "alert",
    "tran",
    "valueDate",
    "remiter",
    "remitername",
    "beneficiary",
    "Trnasactiondescrption",
    "beneficiaryvirtual",
    "debitAmount",
    "credit",
    "Remitterbank",
    "cheque",
    "ifsc",
    "utr",
    "mnemoniccode"
    
  ];
  notFound: string = "not Found";
  fromDate: string = new Date().toISOString().split("T")[0];
  toDate: string = new Date().toISOString().split("T")[0];
  page: number = 1;
  showImage: boolean = false;
  size: number = 10;
  sortField: string = "";
  refreshToken: string = "";
  sortType: string = "";
  totalPage: number = 0;
  totalRecords: number = 0;
  searchPath: string;
  Download: string;
  Calander: string;
  redWarning: string;
  noData: string;
  loading: boolean = false;
  spinnerLoading: boolean = false;
  showDatepicker: boolean = false;
  lastDownloadDate: string = "";
  incremental: boolean = false;
  chooseDate: string;
  now = new Date();
  year = this.now.getFullYear(); // Get the full year (e.g., 2024)
  month = (this.now.getMonth() + 1).toString().padStart(2, "0"); // Get the month (zero-based index, so add 1)
  date = this.now.getDate().toString().padStart(2, "0"); // Get the day of the month
  hours = this.now.getHours().toString().padStart(2, "0"); // Get the hours
  minutes = this.now.getMinutes().toString().padStart(2, "0"); // Get the minutes
  formattedTime: string | any;
  constructor(
    private apiService: ApiService,
    private snackBar: MatSnackBar,
    private app : AppComponent
  ) {
    this.searchPath = "/assets/icons/search.svg";
    this.Download = "/assets/icons/download.svg";
    this.Calander = "/assets/icons/calander.svg";
    this.redWarning = "/assets/icons/redWarning.svg";
    this.noData = "/assets/icons/noData.jpg";
    this.chooseDate = "src/assets/icons/chooseDate.png";
  }
  dateOptions: any = {
    year: "numeric",
    month: "numeric",
    day: "numeric",
  };

  formattedDate = `trandownload_${this.year}${this.month}${this.date}_${this.hours}${this.minutes}`;
  onViewClick(): boolean {
    this.showErrors = true;

    if (this.dateFrom.valid && this.dateTo.valid) {
      return !(
        this.hasDateError(this.dateFrom) || this.hasDateError(this.dateTo)
      );
    }

    return false;
  }

  getErrorMessage(control: FormControl): string {
    return control.hasError("matDatepickerParse")
      ? "Invalid date format"
      : "Invalid date range";
  }

  // Function to check if the control has a date error
  private hasDateError(control: FormControl): boolean {
    return control.invalid && this.showErrors;
  }

  ngOnInit(): void {
    const currentDate = new Date();
    this.fromDate = this.formatDate(currentDate);
    this.toDate = this.formatDate(currentDate);
    this.showDatepicker = this.selectedOption === "TransactionsForPeriod";
    setTimeout(() => {
      this.showSpinner = false;
    }, 1000);
  }

  private formatDate(date: Date): string {
    const year = date.getFullYear();
    const month = this.padZero(date.getMonth() + 1);
    const day = this.padZero(date.getDate());
    return `${year}-${month}-${day}`;
  }

  private padZero(num: number): string {
    return num < 10 ? `0${num}` : `${num}`;
  }

  @ViewChild(MatSort) sort!: MatSort;

  onPageChange(event: PageEvent) {}

  fetchTransactionData(): void {
    const page = this.pageEvent.page;
    this.isLoading = true;
    const accessToken:any = sessionStorage.getItem("accessToken");
    this.apiService
      .fetchTransaction(
        this.fromDate,
        this.toDate,
        page,
        this.size,
        this.sortField,
        this.sortType,
        accessToken,
        this.isError
      )
      .subscribe({
        next: (response) => {
          const responseData = response as any;
          if (responseData.status == 200) {
            this.transactionData = responseData?.data?.data;
            const paginteData = responseData?.data;
            this.pageEvent = {
              page: paginteData.page,
              pageSize: paginteData.pageSize,
              totalPage: paginteData.totalPages,
              totalRecords: paginteData.totalRecords,
            };

            if (this.transactionData.length === 0) {
              this.isError = true;
              this.openSnackBar(
                "No transactions available for Selected period"
              );
            }
          }
          this.isLoading = false;
        },
        error: (error) => {
          // Hide loader in case of error
          this.transactionData = [];
          console.error("Error fetching transaction data:", error);
          if (error.status === 403) {
            this.isError = true;
            this.openSnackBar("User logged out");

            setTimeout(() => {
              this.app.logout();
            }, 2000);
          }
          if (error.status === 401) {
            this.isError = true;
            const refreshToken:any = sessionStorage.getItem("refreshToken");
            // Call refreshToken method
            this.apiService.refreshToken(refreshToken).subscribe({
              next: (res:any) => {
                this.refreshToken = res.data.accessToken
                sessionStorage.removeItem("accessToken");
                sessionStorage.removeItem("refreshToken");
                if (res.data.accessToken && res.data.refreshToken) {
                  sessionStorage.setItem("accessToken", res.data.accessToken);
                  sessionStorage.setItem("refreshToken", res.data.refreshToken);
                }
                this.fetchTransactionData();
              },
              error: (refreshError) => {
                console.error("Error refreshing token:", refreshError);
                this.isError = true;
                this.openSnackBar("User logged out");
  
                setTimeout(() => {
                  this.app.logout();
                }, 2000);
              },

           
            });
          }
        },
      });
  }

  fetchIncrementalTransactionData(): void {
    this.isLoading = true; // Set isLoading to true when starting the API request
    const accessToken:any = sessionStorage.getItem("accessToken");
    this.apiService
      .getIncrementalTransaction(
        this.page.toString() === "0" ? "1" : this.page.toString(),
        this.size.toString() === "1" ? "10" : this.size.toString(),
        this.sortField,
        this.sortType,
        accessToken,
        this.isError
      )
      .subscribe({
        next: (response) => {
          // Update data and pagination properties
          const paginteData = (response as any)?.data;
          this.incrementalTransctiondata = paginteData.data[0].result;
          this.page = paginteData.page;
          this.size = paginteData.pageSize;
          this.totalPage = paginteData.totalPages;
          this.totalRecords = paginteData.totalRecords;
          this.highestEventTSDate = this.lastFormatDate(
            paginteData.data[0].highestEventTSDate
          );
          this.IsDownloaded = paginteData.data[0].isDownloaded;
          this.isLoading = false;
        },
        error: (error) => {
          console.error("Error fetching transaction data:", error);
          if (error.status === 403) {
            this.isError = true;
            this.openSnackBar("User logged out");

            setTimeout(() => {
              this.app.logout();
            }, 2000);
          }
          if (error.status === 401) {
            this.isError = true;
            const refreshToken:any = sessionStorage.getItem("refreshToken");
            // Call refreshToken method
            this.apiService.refreshToken(refreshToken).subscribe({
              next: (res:any) => {
                this.refreshToken = res.data.accessToken
                sessionStorage.removeItem("accessToken");
                sessionStorage.removeItem("refreshToken");
                if (res.data.accessToken && res.data.refreshToken) {
                  sessionStorage.setItem("accessToken", res.data.accessToken);
                  sessionStorage.setItem("refreshToken", res.data.refreshToken);
                }
                this.fetchIncrementalTransactionData();
              },
              error: (refreshError) => {
                console.error("Error refreshing token:", refreshError);
                this.isError = true;
                this.openSnackBar("User logged out");
  
                setTimeout(() => {
                  this.app.logout();
                }, 2000);
              },
            });
          }
          // Set isLoading to false even if there's an error
          this.isLoading = false;
        },
      });
  }

  lastFormatDate(dateString: string): string {
    const date = new Date(dateString);

    const options: Intl.DateTimeFormatOptions = {
      month: "long",
      day: "numeric",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    };

    const formattedDate = new Intl.DateTimeFormat("en-US", options).format(
      date
    );
    return `${formattedDate}`;
  }

  downloadTransactionData(): void {
    this.loading = true;
    const accessToken:any = sessionStorage.getItem("accessToken");
    this.apiService
      .getdownloadTransaction(
        this.fromDate,
        this.toDate,
        this.sortField,
        this.sortType,
        accessToken,
        this.isError
      )
      .subscribe({
        next: (response: Blob) => {
          saveAs(response, `${this.formattedTime}.xlsx`, { autoBom: false });
          this.isError = false;
          this.openSnackBar("Download Completed");
          this.loading = false;
        },
        error: (error) => {
          console.error("Error fetching downloadTransactionData data:", error);
          if (error.status === 403) {
            this.isError = true;
            this.openSnackBar("User logged out");

            setTimeout(() => {
              this.app.logout();
            }, 2000);
          }
          if (error.status === 401) {
            this.isError = true;
            const refreshToken:any = sessionStorage.getItem("refreshToken");
            // Call refreshToken method
            this.apiService.refreshToken(refreshToken).subscribe({
              next: (res:any) => {
                this.refreshToken = res.data.accessToken
                sessionStorage.removeItem("accessToken");
                sessionStorage.removeItem("refreshToken");
                if (res.data.accessToken && res.data.refreshToken) {
                  sessionStorage.setItem("accessToken", res.data.accessToken);
                  sessionStorage.setItem("refreshToken", res.data.refreshToken);
                }
                this.downloadTransactionData();
              },
              error: (refreshError) => {
                console.error("Error refreshing token:", refreshError);
                this.isError = true;
                this.openSnackBar("User logged out");
  
                setTimeout(() => {
                  this.app.logout();
                }, 2000);
              },
            });
          }
          this.loading = false;
        },
      });
  }

  downloadIncrementalTransaction(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.spinnerLoading = true;
      const accessToken:any = sessionStorage.getItem("accessToken");
      this.apiService.getdownloadIncrementalTransaction(accessToken,
        this.isError).subscribe({
        next: (response: Blob) => {
          saveAs(response, `${this.formattedTime}.xlsx`, { autoBom: false });
          this.isError = false;
          this.openSnackBar("Download Completed");
          resolve(response);
          this.spinnerLoading = false;
        },
        error: (error) => {
          reject(error);
          console.error("Error fetching downloadTransactionData data:", error);
          if (error.status === 403) {
            this.isError = true;
            this.openSnackBar("User logged out");

            setTimeout(() => {
              this.app.logout();
            }, 2000);
          }
          if (error.status === 401) {
            this.isError = true;
            const refreshToken:any = sessionStorage.getItem("refreshToken");
            // Call refreshToken method
            this.apiService.refreshToken(refreshToken).subscribe({
              next: (res:any) => {
                this.refreshToken = res.data.accessToken
                sessionStorage.removeItem("accessToken");
                sessionStorage.removeItem("refreshToken");
                if (res.data.accessToken && res.data.refreshToken) {
                  sessionStorage.setItem("accessToken", res.data.accessToken);
                  sessionStorage.setItem("refreshToken", res.data.refreshToken);
                }
                this.downloadIncrementalTransaction();
              },
              error: (refreshError) => {
                console.error("Error refreshing token:", refreshError);
                this.isError = true;
                this.openSnackBar("User logged out");
  
                setTimeout(() => {
                  this.app.logout();
                }, 2000);
              },
            });
          }
          this.spinnerLoading = false;
        },
      });
    });
  }

  onDate(event: MatDatepickerInputEvent<Date>, pickerId: string): void {
    const targetId = pickerId;

    if (targetId === "picker") {
      const selectedDate = event.value;
      if (selectedDate) {
        const nextDate = new Date(selectedDate);
        nextDate.setDate(nextDate.getDate() + 1);
        this.fromDate = nextDate.toISOString().split("T")[0];
      } else {
        this.fromDate = "";
      }
    } else if (targetId === "calander") {
      const selectedDate = event.value;
      if (selectedDate) {
        const nextDate = new Date(selectedDate);
        nextDate.setDate(nextDate.getDate() + 1);
        this.toDate = nextDate.toISOString().split("T")[0];
      } else {
        this.toDate = "";
      }
    }
  }

  dateFilter: (date: Date | null) => boolean = (date: Date | null): boolean => {
    const today = new Date(this.fromDate);
    today.setHours(0, 0, 0, 0);
    return !date || date >= today;
  };

  onViewButtonClick() {
    this.isTrue = true;
    if (this.fromDate == "") {
      this.isError = true;
      this.openSnackBar("Please Select From Date");
    } else if (this.toDate == "") {
      this.isError = true;
      this.openSnackBar("Please Select To Date");
    } else if (this.toDate < this.fromDate) {
      this.isError = true;
      this.openSnackBar("To Date Should Be Greater Than From Date");
    } else {
      if (this.fromDate && this.toDate) {
        this.fetchTransactionData();
      }
    }
  }

  onChange() {
    this.showDatepicker = this.selectedOption === "TransactionsForPeriod";
    if (this.selectedOption === "IncrementalTransactions") {
      this.isTrue = false;
      this.transactionData = [];
      this.fetchIncrementalTransactionData();
    }
  }

  onSortChange(sort: Sort): void {
    const handleSortChange = () => {
      if (this.sortField === sort.active) {
        if (this.sortType === "asc") {
          this.sortType = "desc";
        } else if (this.sortType === "desc") {
          this.sortType = "";
        } else {
          this.sortType = "asc";
        }
      } else {
        this.sortField = sort.active || "";
        this.sortType = "asc";
      }
    };

    if (this.selectedOption === "TransactionsForPeriod") {
      handleSortChange();
      this.fetchTransactionData();
    } else {
      handleSortChange();
      this.fetchIncrementalTransactionData();
    }
  }

  downloadExcel() {
    this.formattedTime = '';
    // Generate the new current time
    const now = new Date();
    const hour = now.getHours().toString().padStart(2, '0');
    const minute = now.getMinutes().toString().padStart(2, '0');
    this.formattedTime = `trandownload_${this.year}${this.month}${this.date}_${hour}${minute}`;
    if (this.selectedOption === "TransactionsForPeriod") {
      this.downloadTransactionData();
      this.fetchTransactionData();
    } else {
      this.downloadIncrementalTransaction()
        .then(() => {
          // Once downloadIncrementalTransaction() is successful, fetch the incremental transaction data
          this.fetchIncrementalTransactionData();
        })
        .catch((error) => {
          // Handle error if downloadIncrementalTransaction() fails
          console.error(
            "Error downloading incremental transaction data:",
            error
          );
        });
    }
  }

  sortData(sort: Sort): void {
    this.transactionData = sort;
  }

  calculateMin(): number {
    if (this.selectedOption === "TransactionsForPeriod") {
      let minvalue = (this.pageEvent.page - 1) * this.pageEvent.pageSize + 1;
      return minvalue > this.pageEvent.totalRecords
        ? this.pageEvent.totalRecords
        : minvalue;
    } else {
      let minvalue = (this.page - 1) * this.size + 1;
      return minvalue > this.totalRecords ? this.totalRecords : minvalue;
    }
  }

  calculateMax(): number {
    if (this.selectedOption === "TransactionsForPeriod") {
      let minvalue = this.pageEvent.page * this.pageEvent.pageSize;
      return minvalue > this.pageEvent.totalRecords
        ? this.pageEvent.totalRecords
        : minvalue;
    } else {
      let minvalue = this.page * this.size;
      return minvalue > this.totalRecords ? this.totalRecords : minvalue;
    }
  }
  calculateTotal(): number {
    if (this.selectedOption === "TransactionsForPeriod") {
      return this.pageEvent.totalRecords;
    } else {
      return this.totalRecords;
    }
  }

  isCurrentPage(page: number | string): boolean {
    if (this.selectedOption === "TransactionsForPeriod") {
      return page === this.pageEvent.page;
    } else {
      return page === this.page;
    }
  }

  getCustomPageRange(): (number | string)[] {
    const currentPage =
      this.selectedOption === "TransactionsForPeriod"
        ? this.pageEvent.page
        : this.page;
    const totalPage =
      this.selectedOption === "TransactionsForPeriod"
        ? this.pageEvent.totalPage
        : this.totalPage;

    const pageRange = 3;
    const startPage = Math.max(1, currentPage - Math.floor(pageRange / 2));
    const endPage = Math.min(totalPage, startPage + pageRange - 1);

    const pages: (number | string)[] = [];

    const addPage = (page: number | string) => {
      pages.push(page);
    };

    const addEllipsisIfNeeded = (start: number, end: number, total: number) => {
      if (start > 1) {
        addPage(1);
      }
      if (start > 2) {
        addPage("...");
      }
      for (let i = start; i <= end; i++) {
        addPage(i);
      }
      if (end < total) {
        addPage("...");
      }
      if (end !== total) {
        addPage(total);
      }
    };

    if (currentPage > 1) {
      addPage("<");
    }

    addEllipsisIfNeeded(startPage, endPage, totalPage);

    if (currentPage < totalPage) {
      addPage(">");
    }

    return pages;
  }

  onPageClick(page: number | string): void {
    const isTransactionsForPeriod =
      this.selectedOption === "TransactionsForPeriod";
    const pagination = isTransactionsForPeriod ? this.pageEvent : this;

    const totalPage = isTransactionsForPeriod
      ? pagination.totalPage
      : this.totalPage;

    if (page === "<" && pagination.page > 1) {
      pagination.page--;
      this.onChange();
    } else if (page === ">" && pagination.page < totalPage) {
      pagination.page++;
      this.onChange();
    } else if (typeof page === "number" && page >= 1 && page <= totalPage) {
      pagination.page = page;
      this.onChange();
    } else {
      console.warn("Invalid page number");
      return;
    }

    if (isTransactionsForPeriod) {
      this.fetchTransactionData();
    } else {
      this.fetchIncrementalTransactionData();
    }
  }

  checkDataImage() {
    if (this.selectedOption === "TransactionsForPeriod") {
      this.onChange();
    }
    return "assets/icons/noData.jpg";
    // }
  }
  openSnackBar(message: string) {
    this.snackBar.open(message, "x", {
      duration: this.isError ? 3000 : 5000,
      horizontalPosition: "center",
      verticalPosition: "top",
      panelClass: this.isError
        ? ["mat-mdc-snack-bar-container", "red"]
        : ["mat-mdc-snack-bar-container", "green"],
    });
  }
}